export default __webpack_public_path__ + "static/media/oe_5.b562bf53.mp3";